import { CarDetailProps } from 'features/car-details-card/types'
import { prepareCarData } from 'features/car/normalization'
import React, { FC, useMemo } from 'react'
import { useTheme } from 'styled-components'

export const CarDetailsCardSSR: FC<CarDetailProps> = ({ baseCarModel, tabs, linkAboutModel, carViewSettings }) => {
  const appTheme = useTheme()

  const carData = useMemo(() => prepareCarData(baseCarModel, carViewSettings, appTheme), [
    appTheme,
    baseCarModel,
    carViewSettings,
    tabs
  ])

  return (
    <>
      <h1>{carData.title}</h1>
      {linkAboutModel && <a href={linkAboutModel.link}>{linkAboutModel.link}</a>}
      <ul>
        {carData.baseSpecifications.map((spec) => (
          <li key={spec.text}>{spec.text}</li>
        ))}
      </ul>
      {tabs.map((tab) => (
        <>
          <h3>{tab.title}</h3>
          {tab.content.element === 'specifications' &&
            tab.content.value.sections.map((section) => {
              return (
                <>
                  <h4>{section.title}</h4>
                  <ul>
                    {section.props.map((prop) => (
                      <li key={prop.title}>
                        {prop.title}: {prop.definition}
                      </li>
                    ))}
                  </ul>
                </>
              )
            })}
          {tab.content.element === 'options' &&
            tab.content.value.sections.items.map((section) => {
              return (
                <>
                  <h4>{section.title}</h4>
                  <ul>
                    {section.content.options.map((option) => (
                      <li key={option}>{option}</li>
                    ))}
                  </ul>
                </>
              )
            })}
        </>
      ))}
    </>
  )
}
